export default __webpack_public_path__ + "static/media/loader.6fb4855b.svg";